import { CropRatioType } from "store/types/crop";

export const getRatioValue = (ratio: CropRatioType): number => {
    if (ratio === "freeform") {
        return 0;
    }

    if (ratio === "original") {
        return 1;
    }

    const ratioWidth = +ratio.split(":")[0] ?? 1;
    const ratioHeight = +ratio.split(":")[1] ?? 1;

    return ratioWidth / ratioHeight;
};
